import { strTemplate } from '@webapp/common/lib/ui';

export const PLACEHOLDER = {
    // TODO split question and ui
    COLUMN: strTemplate`Столбец ${0}`,
    DISQUAL: 'Текст дисквалификации',
    EMAIL: 'user@mail.com',
    EMPTY: '',
    EXCEPTION: 'Исключение',
    FINISH: 'Текст завершения',
    IDX: strTemplate`${0}`,
    LINK_CODE: 'Код ссылки',
    QUESTION_SUB_QUESTION: 'Подвопрос',
    QUESTION_BAD: 'Плохо',
    QUESTION_GOOD: 'Отлично',
    QUESTION_TEXT: 'Текст вопроса',
    CANT_RATE: 'Не могу оценить',
    RANK: 'балл',
    SURVEY: 'Исследование',
    RGB_NUM: '123',
    RGBA_HEX: '#ffffffff',
    ROW: strTemplate`Строка ${0}`,
    SEARCH: 'Поиск',
    SELF: 'Ответ респондента',
    SURVEY_SEARCH: 'Поиск (введите название или ссылку)',
    TEXT: 'Текст ответа',
    KANO_FUNCTION: 'Функция',
    KANO_FUNCTIONAL: 'Как вы отнесётесь, если функция есть?',
    KANO_FUNCTIONAL_NO: 'Как вы отнесётесь, если функции нет?',
    TITLE: 'Название',
    UNIT: 'единица измерения',
    USER_NAME: 'Имя пользователя',
    USER_NIK: 'Ник в ЛК',
    VARIANT: strTemplate`Вариант ${0}`,
    WEB_LINK: 'Ссылка на веб-сайт',
    WEB_SITE_URL_EXAMPLE: 'www.testograf.ru',
    VARIABLE_NAME: 'Название параметра',
    VARIABLE: 'Параметр',
    CREATIVE: 'Название креатива (видно только вам)',
    ADDITIONAL_DESCRIPTION: 'Дополнительное описание',
    ANSWER: 'Впишите текст ответа',
    SIGNATURE: 'Подпись',
    CARD_NAME: 'Название карточки',
    CARD_CATEGORY: 'Название категории',
    ATTRIBUTE: 'Атрибут',
    LEVEL: 'Уровень',
    CARD: 'Карточка',
    CORRECT_ANSWER: 'Вы ответили верно.',
    INCORRECT_ANSWER: 'Вы ответили неверно.',
};

export const TEXTS = {
    redirectText:
        'Включите, чтобы при редиректе сохранить параметры исходной ссылки (UTM и др.). Дополнительно будут переданы id респондента и статус завершения — для учёта ответов в сторонних панелях.',
    CORRECT_ANSWER: 'Вы ответили верно',
    INCORRECT_ANSWER: 'Вы ответили неверно',
};
